import { IWixAPI, Experiments } from '@wix/yoshi-flow-editor';
import { ISearchProductDocument } from '@wix/client-search-sdk';
import { Spec } from '../../../../../lib/specs';

export const addProductToCart = async (
  { id, relativeUrl }: ISearchProductDocument,
  wixCodeApi: IWixAPI,
  experiments: Experiments,
): Promise<void> => {
  const {
    stores: storesApi,
    location: locationApi,
    window: windowApi,
  } = wixCodeApi;

  if (!storesApi) {
    return;
  }

  const isMobile = windowApi.formFactor === 'Mobile';

  // NOTE: We cannot add directly to cart when product has options, custom text fields or
  // subscriptions. As a workaround, we show a quickview on desktop and redirect to product
  // page on mobile.
  try {
    await storesApi.cart.addProducts([{ productId: id, quantity: 1 }]);
  } catch {
    if (!isMobile && experiments.enabled(Spec.AddToCartQuickView)) {
      await storesApi.product.openQuickView(id);
    } else {
      locationApi.to?.(relativeUrl);
    }
    return;
  }

  if (isMobile) {
    await storesApi.navigate.toCart();
  } else {
    storesApi.cart.showMiniCart();
  }
};
